const DEBUGGING: boolean = process.env.NODE_ENV === 'development'

import { BaseObject, MongoObject } from './_baseClasses'
import * as telegram from "./telegram"
import * as utils_time from "./utils_time"
import * as utils from "./utils"
import { Account } from './Account';
import { acquiredType } from './MomentOwned';

export type sortOrderTypes = 'Date_DESC' | 'Date_ASC'

export enum actionTypes {
  Listed = 1, Delisted = 2, Sold = 3, Bought = 4, OpenedPack = 5, ReceivedGift = 6, SendGift = 7, ReceivedReward = 8, Received = 9, 
  AuctionSold = 10, AuctionPurchased = 11, TradedInForTicket = 12, PutIntoPack = 13, 
  OfferMade = 14, OfferAccepted = 15, OfferCanceled = 16,
  Burned = 17, Locked = 18, Unlocked = 19, Minted = 20
}

export class Activity extends BaseObject {
  public momentID: number = null
  public action: actionTypes = null
  public momentText: string = null
  public firstParty?: string = null   // Introduced Apr 13, 2024 when I did activity feeds for moments; firstParty for moment activity feeds is seller or sender; for account activity feeds, we'll just leave it null since it's the person whose activity feed this is
  public counterParty: string = null
  public price: number = null
  public date: Date = null

  // April 16, 2024 -- added while working on moment activity feeds
  public marketplace?: string = null
  public offerID: number = null     // so that sales can say that sale was by offer

  // complex, class-based fields (require to be hydrated after loading from external sources like mongo or elastic)

  constructor(po?: object) {
    super()
    if (po) this.injectPlainObject(po)
    this.hydrate()
  }

  protected hydrate(): void {
    super.hydrate()
    if (typeof this.date === 'string') this.date = new Date(this.date)
  }

  public isSafe(): boolean {
    return true
  }


  public actionText(): string {
    switch (this.action) {
      case actionTypes.Listed: return 'Listed'
      case actionTypes.Delisted: return 'Delisted'
      case actionTypes.Sold: return 'Sold'
      case actionTypes.Bought: return 'Bought'
      case actionTypes.OpenedPack: return 'Pack'
      case actionTypes.ReceivedGift: return 'Received Gift'
      case actionTypes.SendGift: return 'Sent Gift'
      case actionTypes.ReceivedReward: return 'Reward'
      case actionTypes.Received: return 'Received'
      case actionTypes.AuctionSold: return 'Auction Sold'
      case actionTypes.AuctionPurchased: return 'Auction Bought'
      case actionTypes.TradedInForTicket: return 'Traded In'
      case actionTypes.PutIntoPack: return 'Put Into Pack'
      case actionTypes.OfferMade: return 'Made Offer'
      case actionTypes.OfferAccepted: return 'Accepted Offer'
      case actionTypes.OfferCanceled: return 'Canceled Offer'
      case actionTypes.Burned: return 'Burned'
      case actionTypes.Locked: return 'Locked'
      case actionTypes.Unlocked: return 'Unlocked'
      case actionTypes.Minted: return 'Minted'
    }
  }

  public actionTextForMoment(): string {
    switch (this.action) {
      case actionTypes.Listed: return 'Listed'
      case actionTypes.Delisted: return 'Delisted'
      case actionTypes.Sold: return 'Sold'
      case actionTypes.Bought: return 'Bought'
      case actionTypes.OpenedPack: return 'Pack Opened'
      case actionTypes.ReceivedGift: return 'Received Gift'
      case actionTypes.SendGift: return 'Sent'
      case actionTypes.ReceivedReward: return 'Received Reward'
      case actionTypes.Received: return 'Received'
      case actionTypes.AuctionSold: return 'Auction Sold'
      case actionTypes.AuctionPurchased: return 'Auction Bought'
      case actionTypes.TradedInForTicket: return 'Traded In'
      case actionTypes.PutIntoPack: return 'Put Into a Pack'
      case actionTypes.OfferMade: return 'Offer Made'
      case actionTypes.OfferAccepted: return 'Offer Accepted'
      case actionTypes.OfferCanceled: return 'Offer Canceled'
      case actionTypes.Burned: return 'Burned'
      case actionTypes.Locked: return 'Locked'
      case actionTypes.Unlocked: return 'Unlocked'
      case actionTypes.Minted: return 'Minted'
    }
  }

  public static simplifyUsernameAndAddressString(uaas: string) {
    // Regular expression to match the address (0x followed by hexadecimal characters)
    const addressRegex = /0x[0-9a-fA-F]+/;
    // Regular expression to match the username (enclosed in parentheses)
    const usernameRegex = /\(([^)]+)\)/;

    // Extract the address using the addressRegex
    const addressMatch = uaas.match(addressRegex);
    const address = addressMatch ? addressMatch[0] : '';

    // Extract the username using the usernameRegex
    const usernameMatch = uaas.match(usernameRegex);
    const username = usernameMatch ? usernameMatch[1] : ''; // Access the first capture group to exclude parentheses
    
    if (username) return username
    return address

  }

  public fullActionTextForMoment(): string {
    let text = this.actionTextForMoment()
    if (this.firstParty) text += ` by ${Activity.simplifyUsernameAndAddressString(this.firstParty)}`
    if (this.counterParty && this.action !== actionTypes.OfferMade) text += ` to ${Activity.simplifyUsernameAndAddressString(this.counterParty)}`      // don't show seller for OfferMade because seller at the time offer may not match current owner
    if (this.action === actionTypes.Sold && this.offerID) text += ` via an offer`
    if (this.price) text += ` for $${this.price.toFixed(2)}`
    if (this.marketplace) text += ` on ${this.marketplace}`
    return text
  }

  public getClassName(): string {
    return this.actionText().toLocaleLowerCase().replace(/\s/g, '_')
  }
}

(async () => {
})();
